import * as ambassadorWixMembersV1DefaultPrivacy from './members-v1-default-privacy-default-privacy.http.js';
import * as ambassadorWixMembersV1DefaultPrivacyTypes from './members-v1-default-privacy-default-privacy.types.js';
import * as ambassadorWixMembersV1DefaultPrivacyUniversalTypes from './members-v1-default-privacy-default-privacy.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDefaultPrivacyStatus(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1DefaultPrivacyUniversalTypes.GetDefaultPrivacyStatusRequest,
  ambassadorWixMembersV1DefaultPrivacyTypes.GetDefaultPrivacyStatusRequest,
  ambassadorWixMembersV1DefaultPrivacyUniversalTypes.GetDefaultPrivacyStatusResponse,
  ambassadorWixMembersV1DefaultPrivacyTypes.GetDefaultPrivacyStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1DefaultPrivacy.getDefaultPrivacyStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/default-privacy-status',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setDefaultPrivacyStatus(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixMembersV1DefaultPrivacyUniversalTypes.SetDefaultPrivacyStatusRequest,
  ambassadorWixMembersV1DefaultPrivacyTypes.SetDefaultPrivacyStatusRequest,
  ambassadorWixMembersV1DefaultPrivacyUniversalTypes.SetDefaultPrivacyStatusResponse,
  ambassadorWixMembersV1DefaultPrivacyTypes.SetDefaultPrivacyStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1DefaultPrivacy.setDefaultPrivacyStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/default-privacy-status',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DefaultPrivacy as DefaultPrivacyOriginal,
  Privacy as PrivacyOriginal,
  PrivacyWithLiterals as PrivacyWithLiteralsOriginal,
  GetDefaultPrivacyStatusRequest as GetDefaultPrivacyStatusRequestOriginal,
  GetDefaultPrivacyStatusResponse as GetDefaultPrivacyStatusResponseOriginal,
  SetDefaultPrivacyStatusRequest as SetDefaultPrivacyStatusRequestOriginal,
  SetDefaultPrivacyStatusResponse as SetDefaultPrivacyStatusResponseOriginal,
} from './members-v1-default-privacy-default-privacy.types.js';
